import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import Rellax from 'rellax';
//import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from 'swiper';
//Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);

(function($) {$.fn.inviewClass = function(options){var settings = $.extend({className: 'is-inview', secondClassName: 'is-inview-done', visibleOffset: 200, secondClassInterval: 1000 }, options); var isDisabled = false; if(settings.SecondClassName === ''){isDisabled = true; } return this.each(function(){var $this = $(this); function inviewClass(){let currentPos = pageYOffset; if(currentPos > $this.offset().top - window.innerHeight + settings.visibleOffset){if(!$this.hasClass(settings.className)){$this.addClass(settings.className); if(!isDisabled){var thisTimeoutID = setTimeout(function(){$this.addClass(settings.secondClassName); clearTimeout(thisTimeoutID); }, settings.secondClassInterval); } } } } inviewClass(); $(window).on('resize', function(){inviewClass(); }); $(window).on('scroll', function(){inviewClass(); }); }) } })(jQuery);

const dp = [];
dp.body = document.querySelector('body');
dp.wrapper = document.querySelector('#barba-wrapper');
dp.header = document.querySelector('.siteheader');
dp.container = dp.wrapper.lastElementChild;
dp.breakPoint = 600;
dp.headerNav = document.querySelector('.siteheader__nav');
dp.footer = document.querySelector('.sitefooter');
dp.anchorTarget = false;


dp.initMasonry = function(){

  if(dp.container.querySelector('.l-masonry') == null){
    return;
  }

  const masonryElems = dp.container.querySelectorAll('.l-masonry');

  for(let i = 0; i < masonryElems.length; i++){
    const thisItem = masonryElems[i];

    const imgElems = thisItem.querySelectorAll('img');

    let thisMasonry = '';

    function loaded() {
      thisMasonry = new Masonry(thisItem, {
        itemSelector: '.l-masonry__item',
        gutter: 32,
        percentPosition: true,
        horizontalOrder: true
      })
    }

    imagesLoaded(masonryElems, loaded);

  }
}

window.addEventListener('DOMContentLoaded', ()=> {
  dp.initMasonry();
})

dp.initparallax = function(){


  if(dp.container.querySelector('.rellax-centered') == null) {
    return;
  }

  let rellax,
      rellaxCentered,
      isParallaxInitialized = false;

  function toggleParallax(){
    if(window.innerWidth > dp.breakPoint){
      if(!isParallaxInitialized){
        isParallaxInitialized = true;
        /*
        rellax = new Rellax('.rellax', {
          speed: 2,
          //center:true
        });*/

        rellaxCentered = new Rellax('.rellax-centered', {
          speed: 1,
          center:true
        });
      }
    } else {
      if(isParallaxInitialized){
        isParallaxInitialized = false;
        rellaxCentered.destroy();
        //rellax.destroy();
      }
    }
  }
  //toggleParallax()

  $('.section-artist').imagesLoaded(function(){
    //toggleParallax();
  })
  const parallaxElems = dp.container.querySelectorAll('.rellax-centered')

  imagesLoaded(parallaxElems, toggleParallax);


  window.addEventListener('resize', ()=> {
    toggleParallax();
  })
}
dp.initparallax();


dp.initInviewClass = function(){
  $('.js-inview').inviewClass({
    visibleOffset: 200,
    secondClassInterval: 1000
  });
}
dp.initInviewClass();



dp.sendGA = function(){
  if(!dp.body.classList.contains('is-user-logged-in')){
    //console.log('計測を実行、開発中のため計測を停止中');
    gtag('config', 'G-VJSW4ZZ3JC');
  } else {
    //console.log('ログインユーザーは計測しない');
  }
}


dp.lazyload = function(){

  let currentPos = pageYOffset,
      lazyloadThreshold = 200;

  function doLazyload(){
    currentPos = pageYOffset;

    $('.js-lazyload', dp.container).each(function(){

      let $this = $(this);
      if(currentPos > $this.offset().top - window.innerHeight - lazyloadThreshold){

        if(!$this.hasClass('js-lazyload-done')){

          $this.addClass('js-lazyload-done');
          $this.attr('src', $this.data('src'));

        }

      }
    })
  }
  doLazyload();

  $(window).on('resize scroll', function(){
    doLazyload();
  })

}
dp.lazyload();


dp.anchorTo = (targetID, callback) => {

  if(!targetID){
    return;
  }

  let $target = dp.container.querySelector('#' + targetID),
      waitTime = 0,
      thisOffset = -72;

  if(targetID == 'hero'){
    thisOffset = 0;
  }

  if(window.innerWidth < dp.breakPoint){
    thisOffset = -64;
  }

  //ローカルナビのOFFSET
  if(dp.container.querySelector('.c-localnav') !== null ){

    const headLocalNavFixed = document.querySelector('.c-localnavfixed');
    let localNavFixedOffet = 112;

    if(window.innerWidth > dp.breakPoint){
      localNavFixedOffet = 112;
    } else {
      localNavFixedOffet = 64;
    }
    thisOffset = (localNavFixedOffet + headLocalNavFixed.clientHeight) * -1;
  }


  $.Velocity($target, 'scroll', {
    duration: 800,
    easing: "easeInOutCubic",
    offset: thisOffset,
    delay: waitTime,
    complete: ()=> {
      if(callback){
        callback();
      }
      dp.anchorTarget = false;
    }
  })
}


dp.initPageTop = () => {

  if(document.querySelector('.c-pagetop') == null) {
    return;
  }

  const pageTopElem = document.querySelector('.c-pagetop'),
        topElement = document.querySelector('#barba-wrapper');

  pageTopElem.addEventListener('click', (event)=> {
    event.preventDefault();
    $.Velocity(topElement, 'scroll', {
      duration: 800,
      easing: "easeInOutCubic",
      offset: 0,
      delay: 0,
      complete: ()=> {
        dp.anchorTarget = false;
      }
    })
  })
}
dp.initPageTop();



dp.initAnchorlink = function(){

  if(dp.container.dataset.page === 'home'){
    const pageTopArray = document.querySelectorAll('.siteheader__logo a, .sitefooter__logo');
    for(let i = 0; i < pageTopArray.length; i++){
      pageTopArray[i].addEventListener('click', (event)=> {
        event.preventDefault();
        dp.anchorTo('hero');
      })
    }
  }
}
dp.initAnchorlink();


dp.initMenu = function(){

  const menuIcon = document.querySelector('.js-menu-icon'),
        menu = document.querySelector('.js-menu-body'),
        menuBody = document.querySelector('.js-menu-body'),
        menuOverlay = document.querySelector('.js-menu-overlay'),
        menuContent = document.querySelector('.js-menu-content');

  dp.openMenu = function(){
    dp.body.classList.add('is-menu-open')
    menuBody.style.display = 'block';
    menuContent.style.opacity = 0;

    $.Velocity(menuOverlay, {
      translateX: [0, window.innerWidth * -1]
    }, {
      duration: 800,
      easing: 'easeOutExpo',
      begin: ()=> {
        setTimeout(()=> {
          $.Velocity(menuContent, {
            opacity: 1
          }, {
            duration: 600,
            easing: 'easeOutQuad',
          })
        }, 200);
      }
    })
  }

  dp.closeMenu = function(){

    $.Velocity(menuContent, {
      opacity: 0
    }, {
      duration: 200,
      easing: 'easeOutQuad',
      begin: ()=> {
        dp.body.classList.remove('is-menu-open')
        setTimeout(()=> {
          $.Velocity(menuOverlay, {
            translateX: [window.innerWidth, 0]
          }, {
            duration: 600,
            easing: 'easeOutQuart',
            complete: ()=> {

              menuBody.style.display = 'none';
            }
          })
        }, 100);
      }
    })
  }

  menuIcon.addEventListener('click', ()=> {
    if(!dp.body.classList.contains('is-menu-open')){
      dp.openMenu();
    } else {
      dp.closeMenu();
    }
  })

  const menuLinkArray = menuBody.querySelectorAll('a')
  for(let i = 0; i < menuLinkArray.length; i++){
    menuLinkArray[i].addEventListener('click', ()=> {
      dp.closeMenu();
      if(menuLinkArray[i].classList.contains('js-anchor') || menuLinkArray[i].classList.contains('js-pagetop')) {
        dp.closeMenu();
      }
    })
  }
}
dp.initMenu();


dp.initScrollFunc = ()=> {
  const header = document.querySelector('.siteheader'),
        footer = document.querySelector('.sitefooter');


  let scrolledOffset = 150;

  if(window.innerWidth > dp.breakPoint){
    scrolledOffset = 150;
  } else {
    scrolledOffset = 100;
  }

  let currentPos = window.pageYOffset;

  function scrollFunc() {
    currentPos = window.pageYOffset;

    if(currentPos > scrolledOffset){
      if(!dp.body.classList.contains('is-scrolled')){
        dp.body.classList.add('is-scrolled');
      }
    } else {
      if(dp.body.classList.contains('is-scrolled')){
        dp.body.classList.remove('is-scrolled')
      }
    }

    if(currentPos > $(footer).offset().top - window.innerHeight){
      if(!dp.body.classList.contains('is-footer-visible')){
        dp.body.classList.add('is-footer-visible')
      }
    } else {
      if(dp.body.classList.contains('is-footer-visible')){
        dp.body.classList.remove('is-footer-visible')
      }
    }

  }
  scrollFunc()

   window.addEventListener('scroll', ()=> {
    scrollFunc()
  })

  window.addEventListener('resize', ()=> {
    if(window.innerWidth > dp.breakPoint){
      scrolledOffset = 150;
    } else {
      scrolledOffset = 100;
    }
  })

}
dp.initScrollFunc();



dp.initNavigations = ()=> {

  const currentPostType = dp.container.dataset.page,
        headerNavLinkElemArray = dp.headerNav.querySelectorAll('a');

  for(let i = 0; i < headerNavLinkElemArray.length; i++){
    const thisLink = headerNavLinkElemArray[i];
    thisLink.classList.remove('is-current');

    let thisText = thisLink.querySelector('span').innerHTML;
    thisText = thisText.replace(/\s+/g, '-');

    if(currentPostType.indexOf(thisText.toLowerCase()) > -1){
      thisLink.classList.add('is-current')
    }
  }
}
window.addEventListener('DOMContentLoaded', ()=> {
  dp.initNavigations();
})


dp.initExhibitionToggle = function(){

  if(dp.container.querySelector('.past-more') == null) {
    return;
  }

  const moreButton = dp.container.querySelector('.past-more'),
        hiddenBlock = dp.container.querySelector('.past-hidden');

  moreButton.addEventListener('click', (event)=> {
    moreButton.classList.add('is-disabled');
    event.preventDefault();

    $.Velocity(moreButton, 'fadeOut', {
      duration: 300,
      easing: 'easeInOutCubic',
      begin: ()=> {

        setTimeout(()=> {
          $.Velocity(hiddenBlock, 'slideDown', {
            duration: 600,
            easing: 'easeInOutCubic'
          })
        }, 100);

      }
    })

  })
}
dp.initExhibitionToggle();


dp.initBridalLangList = function(){

  if(dp.container.querySelector('.c-langlist') == null){
    return;
  }
  /*
  const langList = dp.container.querySelector('.c-langlist'),
        langSelectElems = dp.container.querySelectorAll('.c-langlist__item a'),
        langBlockElems = dp.container.querySelectorAll('.howtoorder-langblock'),
        displayArea = dp.container.querySelector('.howtoorder-langblock-container');

  let currentLang = 'ja';
  let currentBlock,
      nextBlock;
  */

  /*
  切り替えをクリック
    フェードアウト
      フェードアウト中にもクリックでき、指定された言語が変わる

    フェードイン完了前にも言語が変われば、フェードインも変わる
    指定された言語をフェードイン

    フェードアウトする関数
      エリアがフェードアウト

    フェードインする関数（指定の言語）
      フェードイン前に動きを停止
      指定の言語がフェードイン
  */
  const $langList = $('.c-langlist'),
        $displayArea = $('.howtoorder-langblock-container');

  let currentLang = 'ja';
  $('.c-langlist__item').eq(0).addClass('is-current');

  $('.c-langlist__item').each(function(index){

    const $this = $(this);

    $('a', $this).on('click', function(event){
      event.preventDefault();

      if($('a', $this).data('lang') == currentLang) {
        //console.log('return');
        return;
      }
      currentLang = $('a', $this).data('lang');
      //console.log(currentLang);

      $('.c-langlist__item').removeClass('is-current');
      $this.addClass('is-current')

      $displayArea.css({'min-height': ''});
      $displayArea.css({'min-height': $displayArea.innerHeight()});

      $('.howtoorder-langblock').stop().velocity('fadeOut', {
          duration: 200,
          complete: function(){
            //console.log('complete');
            $('.howtoorder-langblock[data-lang="'+currentLang+'"]').delay(200).velocity('fadeIn', {
              duration: 600,
              easing: 'easeInOutQuad',
              complete: function(){
                $displayArea.css({'min-height': ''});
              }
            })
          }
      });
    })

  })


  /*
  for(let i = 0; i < langSelectElems.length; i++){
    const thisSelect = langSelectElems[i];

    thisSelect.addEventListener('click', (event)=> {
      event.preventDefault();

      if(langList.classList.contains('is-animating')){
        //return;
      } else {
        //langList.classList.add('is-animating');
      }

      //console.log(thisSelect.dataset.lang);
      $('.c-langlist__item').each(function(){
        $(this).removeClass('is-current');
      })

      $(thisSelect).parent('.c-langlist__item').addClass('is-current')

      if(thisSelect.dataset.lang !== currentLang){

        //表示中と次表示のブロックを取得
        for(let j = 0; j < langBlockElems.length; j++){
          const thisBlock = langBlockElems[j];

          //表示中のblock
          if(thisBlock.dataset.lang === currentLang){
            currentBlock = thisBlock;
          }

          //次に表示するブロック
          if(thisBlock.dataset.lang === thisSelect.dataset.lang){
            nextBlock = thisBlock
          }
        }

        //表示エリアに最低高さを入れてガタ付きを抑制
        displayArea.style.minHeight = '';
        displayArea.style.minHeight = currentBlock.clientHeight + 'px';

        //フェードアウト + フェードイン
        $.Velocity(currentBlock, 'stop');
        $.Velocity(currentBlock, 'fadeOut', {
          duration: 200,
          complete: function(){
            console.log('fadeOut complete');

            setTimeout(()=> {
              $.Velocity(currentBlock, 'stop');
              $.Velocity(nextBlock, 'fadeIn', {
                duration: 400,
                easing: 'easeInOutQuad',
                complete: function(){
                  console.log('fadeIn complete');
                  console.log('=========================');
                  //langList.classList.remove('is-animating');
                //currentを更新
                currentLang = thisSelect.dataset.lang;
                displayArea.style.minHeight = '';
                }
              });
            }, 100);



          }
        })
      }
    })
  }*/


}
document.addEventListener('DOMContentLoaded', ()=> {
  dp.initBridalLangList();
})

dp.heroSlider;

dp.initHeroSlider = function(){

  if(dp.container.querySelector('.js-heroslider') == null){
    return;
  }

  const heroSliderElem = dp.container.querySelector('.js-heroslider'),
        heroSliderSlides = heroSliderElem.querySelectorAll('.swiper-slide');

  if(heroSliderSlides.length === 1){
    return;
  }

  let isFirstMoveDone = false;

  const leavingAnimationSpeed = 800,
        loopInterval = 4000;

  dp.heroSlider = new Swiper(heroSliderElem, {
    loop: true,
    speed: 0,
    spaceBetween: 0,
    effect: 'fade',
    allowTouchMove: true,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: loopInterval,
      disableOnInteraction: false,
    },
    breakpoints: {
      // when window width is >= 768
      769: {
        //speed: 800,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        $('.swiper-slide-active').addClass('is-kenburns');
            //初回のみinviewclass
          setTimeout(function(){
            isFirstMoveDone = false
              $('.js-inview-short').inviewClass({
                visibleOffset: 0,
                secondClassInterval: 1000
              });
          }, 1200);
      },
    },
  })


  let $lastSlide = $('.swiper-slide-active'),
      $currentSlide;

  $(dp.heroSlider.navigation.nextEl).on('click', (event)=> {

  })



  dp.heroSlider.on('slideChangeTransitionStart', ()=> {

    //切り替え中はスライド操作を受け付けない
    $(heroSliderElem).addClass('is-ignoring');
    dp.heroSlider.allowSlideNext = false;
    dp.heroSlider.allowSlidePrev = false;

    //切り替わった後のスライドにis-kenburns
    $currentSlide = $('.swiper-slide-active');
    $currentSlide.addClass('is-kenburns');

    //表示していたスライドにis-leaving
    $lastSlide.addClass('is-leaving')

    //leavingのアニメーションが終わったら、is-leavingクラスを外す
    //activeでないスライドのis-kenburnsも外す
    setTimeout(function(){
      $lastSlide.removeClass('is-leaving')
      $lastSlide = $('.swiper-slide-active')

      $(heroSliderElem).removeClass('is-ignoring');
      dp.heroSlider.allowSlideNext = true;
      dp.heroSlider.allowSlidePrev = true;
      $('.swiper-slide').not('.swiper-slide-active').removeClass('is-kenburns');



    }, leavingAnimationSpeed + 100);

  })
}
window.addEventListener('DOMContentLoaded', ()=> {
  //dp.initHeroSlider();
})


dp.initImageboardSlider = function(){

  if(dp.container.querySelector('.js-imageboardslider') == null){
    return;
  }

  const imageboardSliderElem = dp.container.querySelector('.js-imageboardslider');

  const imageboardSlider = new Swiper(imageboardSliderElem, {
    loop: true,
    speed: 1200,
    spaceBetween: 0,
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  })
}
dp.initImageboardSlider();


dp.detectStickySticked = function(){
  //console.log('sticked');

  if(dp.container.querySelector('.exhibition-header') !== null){

    const stickyElemContainer = dp.container.querySelector('.l-pagebody');

    let headerBottomPos = dp.header.clientHeight,
        currentPos = window.pageYOffset;

    function scrollFunc(){
      headerBottomPos = dp.header.clientHeight;
      currentPos = window.pageYOffset;

      if(currentPos > $(stickyElemContainer).offset().top - headerBottomPos){
        if(!dp.body.classList.contains('is-sticky-sticked')){
          dp.body.classList.add('is-sticky-sticked')
        }
      } else {
        if(dp.body.classList.contains('is-sticky-sticked')){
          dp.body.classList.remove('is-sticky-sticked')
        }
      }
    }
    scrollFunc();

    window.addEventListener('scroll', ()=> {
      scrollFunc();
    })

  } else {
    dp.body.classList.remove('is-sticky-sticked')
  }

}
dp.detectStickySticked();

dp.setPartsLayout = function(){

  if(dp.container.dataset.page == 'home'){
    dp.body.classList.add('home')
  } else {
    dp.body.classList.remove('home')
  }
  dp.wrapper.style.minHeight = window.innerHeight - dp.footer.clientHeight + 'px';

  window.addEventListener('resize', ()=> {
    dp.wrapper.style.minHeight = window.innerHeight - dp.footer.clientHeight + 'px';
  })

  //bridal 商品ページで問い合わせるリンクを文中に入れ込む
  if(dp.container.dataset.page == 'detail-bridal-child'){

    const $targetLink = $('.c-pagehead__link', dp.container).html();
    const $targetBlock = $('.base-content .l-inner__inside', dp.container).eq(0);

    $targetBlock.append('<p class="show-sml">' + $targetLink + '</p>');
  }

  //サイドバーがウインドウに収まらない時、stickyさせない
  if(dp.wrapper.querySelector('.l-sidebarlayout__side') !== null){
    const sidebar = dp.wrapper.querySelector('.l-sidebarlayout__side'),
          sidebarInnerElem = sidebar.querySelector('.inner');

    let stickyAreaMargin = 120;
    function checkStickyArea(){
      if(sidebarInnerElem.clientHeight > window.innerHeight - dp.header.clientHeight - stickyAreaMargin){
        //console.log('not stick')
        dp.body.classList.add('is-not-sticky');
      } else {
        //console.log('stick')
        dp.body.classList.remove('is-not-sticky');
      }
    }
    checkStickyArea();

    $(window).on('resize', function(){
      checkStickyArea();
    });


  }

}

window.addEventListener('DOMContentLoaded', ()=> {
  dp.setPartsLayout();
});


dp.initContact = function(){


  if(dp.container.dataset.page == 'page-contact'){


    const $privacyBox = $('#privacy-box');
    const path = $privacyBox.data('url');
    let privacyHTML = '';

    $.ajax(path, {
      timeout : 10000,
      datatype:'html'
    }).then(function(data){

      privacyHTML = $($.parseHTML(data)).find('.base-content').html();

    }).catch(function(){
      privacyHTML = [
        '読み込みエラーが発生しました。',
      ].join('');;
    }).then(function() {
      $privacyBox.html(privacyHTML);
    });

  }

}

window.addEventListener('DOMContentLoaded', ()=> {
  dp.initContact();
});


dp.showHideItem = function(){

  $('.is-hide').each(function(index){
    const $this = $(this);
    setTimeout(()=> {
      $this.removeClass('is-hide');
    }, index * 160);
  })
}
window.addEventListener('DOMContentLoaded', ()=> {
  dp.showHideItem();
});


//loadingはsessionStorageで管理
dp.isLoaded = false;
dp.hasSessionData = false;
dp.loadingElem = document.querySelector('.loading');
//dp.hasSessionData = sessionStorage.getItem('has-sessiondata')//dev
//console.log('開発のためsessionData見るのを停止')

ld.loadingEndTime = new Date();

dp.initLoading = function(){


  function loadingSequence(){

    ld.rootElem.classList.add('is-loading-start');

    let transitionTime = 2400 + 200 + 400,//transition + transition-delay + statictime
        filterOutWaitTime = 450;

    if(ld.isLoadingStarted){
      transitionTime = transitionTime - (ld.loadingEndTime.getTime() - ld.loadingStartTime.getTime())
    }

    setTimeout(()=> {
      ld.rootElem.classList.add('is-loading-end');

      setTimeout(()=> {
        $.Velocity(dp.loadingElem, 'fadeOut', {
          duration: 1000,
          easing: "easeInOutCubic",
          complete: function(){
            ld.isinitialLoadingDone = true;
            ld.isinitialLoading = false;
          }
        });

        setTimeout(function(){
          ld.rootElem.classList.remove('is-loading-start');
          ld.rootElem.classList.remove('is-loading-end');
        }, 2000);

        dp.initHeroSlider();
      }, filterOutWaitTime);

    }, transitionTime);
  }
  //loadingSequence()

  //ローディングが長いので onload や時間を待たない。
  //sessionDataあればローディング・なければサイトホームならスライダースタート

  if(dp.container.dataset.page === 'home'){

    if(ld.hasSessionData === 'yes'){
      dp.initHeroSlider();
      //console.log('00')
    } else {
      sessionStorage.setItem('has-sessiondata', 'yes');
      ld.hasSessionData = sessionStorage.getItem('has-sessiondata')

      if(ld.isinitialLoading){
        //console.log('initial')
        dp.loadingElem.style.display = 'block';
        loadingSequence();
      } else {
        //console.log('not initial')
        $.Velocity(dp.loadingElem, 'fadeIn', {
          duration: 200,
          easing: "easeInOutCubic",
          complete: function(){
            loadingSequence();
            //console.log('01')
          }
        });
      }
    }

  } else {
    dp.loadingElem.style.display = 'none';
  }

}
if(ld.hasSessionData === 'yes'){
  dp.loadingElem.style.display = 'none';
}

window.addEventListener('DOMContentLoaded', ()=> {
  dp.initLoading();
})



dp.initBarba = function() {

  dp.fadeOutTime = 300;

  Barba.Pjax.start();

  var FadeTransition = Barba.BaseTransition.extend({
    start: function() {

      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this));
    },

    fadeOut: function() {

      //let fadeTime = 300;
      //menu経由時はfadetimeを0に

      if(dp.container.dataset.page === 'home'){
        dp.heroSlider.destroy();
      }

      return $.Velocity(this.oldContainer, {
        opacity: 0,
      },{
        duration: dp.fadeOutTime,
        easing: 'easeOutQuad',
        complete: function(){
          if(dp.heroSliderRAF){
            cancelAnimationFrame(dp.heroSliderRAF);
          }
        }
      })
      $.promise();
    },

    fadeIn: function() {

      var _this = this;
      var thisNewContainer = this.newContainer;

      this.oldContainer.style.display = 'none';

      $(window).scrollTop(0);
      dp.lazyload();
      dp.initMasonry();
      dp.initparallax();
      //dp.initHeroSlide();

      let fadeTime = 1000;


      thisNewContainer.style.visibility = 'visible';
      thisNewContainer.style.opacity = '0';

      let pageBody = false;

      if(thisNewContainer.querySelector('.l-pagebody') !== null){
        pageBody = thisNewContainer.querySelector('.l-pagebody')
        pageBody.style.opacity = '0';
      }

      setTimeout(()=> {
        $.Velocity(thisNewContainer, {
          opacity: 1
        },{
          duration: 1000,
          easing: 'easeInOutQuad',
          begin: function(){

            _this.done();

            setTimeout(()=> {
              dp.showHideItem();
              if(!pageBody){
                return;
              }
              $.Velocity(pageBody, {
                opacity: 1
              },{
                duration: 1000,
                easing: 'easeInOutQuad',
              })
            }, 400);

          }
        })
      }, 300);




    }
  });

  //if($('.ua-ie, .ua-edge').length < 1){
    Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
    Barba.Pjax.preventCheck = function(evt, element) {

      if(element){

        //WordPressの管理バーのリンクはPjaxを無効に
        if(element.classList.contains('ab-item')){
          return false;
        }
        //編集ボタンのリンクはPjaxを無効に
        if(element.classList.contains('editlink')){
          return false;
        }

        if($(element).parent().hasClass('menunav__item') || $(element).hasClass('sitemenu__logo')){
          dp.fadeOutTime = 100;
        } else {
          dp.fadeOutTime = 240;
        }


        // アンカーリンクであり同一ページでなければPjaxを有効に
        let url = location.protocol + '//' + location.host + location.pathname;
        let extract_hash = element.href.replace(/#.*$/,"");
        if (element.href.startsWith(location.protocol + '//' + location.host)) {
          if (element.href.indexOf('#') > -1 &&  extract_hash != url ){
            dp.anchorTarget = element.href.split('#')[1];
            return true;
          } else {
            const anchorTarget = element.href.split('#')[1];
            dp.anchorTo(anchorTarget);
          }
        }

        if (!Barba.Pjax.originalPreventCheck(evt, element)) {
          return false;
        }
      } else {
        return false;
      }
      return true;

    };



  Barba.Pjax.getTransition = function() {
    return FadeTransition;
  };

  Barba.Dispatcher.on('newPageReady', function() {
    //console.log('newPageReady');
    dp.container = dp.wrapper.lastElementChild;

    //dp.initHeroSlider();
    dp.setPartsLayout();
    dp.initExhibitionToggle();
    dp.initBridalLangList();
    dp.initNavigations();
    dp.initContact();
    dp.initInviewClass();
    dp.initImageboardSlider();
    dp.initLoading();
    dp.detectStickySticked();


  });

  Barba.Dispatcher.on('transitionCompleted', function() {
    //console.log('transitionCompleted');
    dp.anchorTo(dp.anchorTarget);
    dp.sendGA();

  });
}
dp.initBarba();


window.addEventListener('DOMContentLoaded', ()=> {
  dp.body.classList.add('is-ready')
  dp.sendGA();
})


